// Shared helpers for trends tabs.

// Hand-picked categorical palette — high enough contrast on the dark theme,
// stays distinguishable for a stacked area of ~8 series + an Other bucket.
export const TRENDS_PALETTE = [
  '#6c8cff', // accent
  '#e07060',
  '#f0b440',
  '#7fc94c',
  '#56b3c4',
  '#b88cff',
  '#e070b8',
  '#a09080',
  '#888888', // reserved for "Other"
];

export function colorFor(i: number): string {
  return TRENDS_PALETTE[i % TRENDS_PALETTE.length];
}

/** Map a Neo4j label to the entity-detail route segment. */
export function entityHref(label: string, name: string): string | null {
  if (!name) return null;
  const enc = encodeURIComponent(name);
  switch (label) {
    case 'MalwareFamily':
      return `/families/${enc}`;
    case 'ThreatActor':
      return `/actors/${enc}`;
    default:
      return null;
  }
}
